import { AccountTransactionType, AccountTransactionTypesRequest } from 'vopay';
import { useState } from 'react';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useFetchPartnerTransactionTypes() {
  const [fetchingTransactions, setFetchingTransactions] = useState(false);
  const [transactionTypes, setTransactionTypes] = useState<AccountTransactionType[]>([]);

  async function fetchPartnerTransactionTypes(request: AccountTransactionTypesRequest) {
    try {
      setFetchingTransactions(true);
      const res = await api.fetchPartnerTransactionTypes(request);
      setTransactionTypes(res.TransactionTypes);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (err) {
      console.error(err);

      throw err;
    } finally {
      setFetchingTransactions(false);
    }
  }

  return {
    fetchingTransactions,
    transactionTypes,
    fetchPartnerTransactionTypes,
  };
}
